import { ConflictErrorHandler } from '../adapters/ConflictErrorHandler'
import { GeneralErrorHandler } from '../adapters/GeneralErrorHandler'
import { InvalidTokenErrorHandler } from '../adapters/InvalidTokenErrorHandler'
import { LeafletCreationErrorHandler } from '../adapters/LeafletCreationErrorHandler'
import { LeafletValidationErrorHandler } from '../adapters/LeafletValidationErrorHandler'
import { ErrorHandlerRegistry } from '../services/ErrorHandlerRegistry'
import { HttpErrorHandlerService } from '../services/HttpErrorHandlerService'

export class ErrorHandlerServiceFactory {
  static createDefault(): HttpErrorHandlerService {
    const registry = new ErrorHandlerRegistry()

    // Register all default error handlers
    // Order doesn't matter as they're sorted by priority internally
    registry.register(new InvalidTokenErrorHandler())
    registry.register(new ConflictErrorHandler())
    registry.register(new LeafletCreationErrorHandler())
    registry.register(new LeafletValidationErrorHandler())
    registry.register(new GeneralErrorHandler()) // Fallback - lowest priority

    return new HttpErrorHandlerService(registry)
  }

  /**
   * Creates a minimal error handler service with only basic handlers
   * Useful for testing or specific use cases
   */
  static createMinimal(): HttpErrorHandlerService {
    const registry = new ErrorHandlerRegistry()

    registry.register(new InvalidTokenErrorHandler())
    registry.register(new GeneralErrorHandler())

    return new HttpErrorHandlerService(registry)
  }

  /**
   * Creates an empty error handler service for custom configuration
   */
  static createEmpty(): HttpErrorHandlerService {
    const registry = new ErrorHandlerRegistry()
    return new HttpErrorHandlerService(registry)
  }
}
